export default "__VITE_ASSET__mU4qtwWz__"